"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAuthApiRouteRequestForPagesRouter = void 0;
const utils_1 = require("./utils");
const handlers_1 = require("./handlers");
const handleAuthApiRouteRequestForPagesRouter = async ({ request, response, userPoolClientId, oAuthConfig, handlerInput, origin, setCookieOptions, runWithAmplifyServerContext, }) => {
    if (request.method !== 'GET') {
        response.status(405).end();
        return;
    }
    const { slug } = request.query;
    // don't support [...slug] here
    if (slug === undefined || Array.isArray(slug)) {
        response.status(400).end();
        return;
    }
    if (!(0, utils_1.isSupportedAuthApiRoutePath)(slug)) {
        response.status(404).end();
        return;
    }
    switch (slug) {
        case 'sign-up': {
            const hasActiveUserSession = await (0, utils_1.hasActiveUserSessionWithPagesRouter)({
                request,
                response,
                runWithAmplifyServerContext,
            });
            if (hasActiveUserSession) {
                response.redirect(302, (0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignInComplete));
                return;
            }
            (0, handlers_1.handleSignInSignUpRequestForPagesRouter)({
                customState: handlerInput.customState,
                oAuthConfig,
                origin,
                request,
                response,
                setCookieOptions,
                type: 'signUp',
                userPoolClientId,
            });
            break;
        }
        case 'sign-in': {
            const hasActiveUserSession = await (0, utils_1.hasActiveUserSessionWithPagesRouter)({
                request,
                response,
                runWithAmplifyServerContext,
            });
            if (hasActiveUserSession) {
                response.redirect(302, (0, utils_1.getRedirectOrDefault)(handlerInput.redirectOnSignInComplete));
                return;
            }
            (0, handlers_1.handleSignInSignUpRequestForPagesRouter)({
                customState: handlerInput.customState,
                oAuthConfig,
                origin,
                request,
                response,
                setCookieOptions,
                type: 'signIn',
                userPoolClientId,
            });
            break;
        }
        case 'sign-out':
            (0, handlers_1.handleSignOutRequestForPagesRouter)({
                oAuthConfig,
                origin,
                response,
                setCookieOptions,
                userPoolClientId,
            });
            break;
        case 'sign-in-callback':
            // In pages router the response is sent via calling `response.end()` or
            // `response.send()`. The response is not returned from the handler.
            // To ensure these two methods are called before the handler returns,
            // we use `await` here.
            await (0, handlers_1.handleSignInCallbackRequestForPagesRouter)({
                handlerInput,
                oAuthConfig,
                origin,
                request,
                response,
                setCookieOptions,
                userPoolClientId,
            });
            break;
        case 'sign-out-callback':
            // In pages router the response is sent via calling `response.end()` or
            // `response.send()`. The response is not returned from the handler.
            // To ensure these two methods are called before the handler returns,
            // we use `await` here.
            await (0, handlers_1.handleSignOutCallbackRequestForPagesRouter)({
                handlerInput,
                oAuthConfig,
                origin,
                request,
                response,
                setCookieOptions,
                userPoolClientId,
            });
            break;
        // default:
        // is unreachable by the guard of isSupportedAuthApiRoutePath()
    }
};
exports.handleAuthApiRouteRequestForPagesRouter = handleAuthApiRouteRequestForPagesRouter;
